var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcWhatsApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1262_3720)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 8,
    fill: "#25D366"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1262_3720)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9125 4.51544C10.9099 3.51712 9.57652 2.96706 8.15578 2.96655C5.22823 2.96655 2.84563 5.33573 2.84461 8.24788C2.8441 9.17882 3.08883 10.0875 3.55359 10.8883L2.80005 13.6254L5.61556 12.891C6.39125 13.3119 7.26473 13.5335 8.1535 13.5338H8.15578C11.0828 13.5338 13.4657 11.1643 13.4667 8.25218C13.4672 6.84082 12.9154 5.51402 11.9125 4.5157V4.51544ZM8.15578 12.6418H8.154C7.362 12.6416 6.58506 12.4298 5.90716 12.0299L5.74595 11.9347L4.07513 12.3706L4.52104 10.7505L4.41612 10.5844C3.97428 9.88542 3.74076 9.07752 3.74127 8.24814C3.74229 5.8278 5.72252 3.85851 8.15759 3.85851C9.33664 3.85901 10.4449 4.31614 11.2784 5.14604C12.1119 5.9757 12.5706 7.07888 12.5701 8.25168C12.569 10.6723 10.5888 12.6416 8.15578 12.6416V12.6418ZM10.5771 9.35409C10.4444 9.288 9.79199 8.96888 9.67024 8.92483C9.54852 8.88075 9.46017 8.85874 9.37178 8.99092C9.28343 9.12313 9.02903 9.42045 8.9516 9.50831C8.87418 9.59645 8.79676 9.60735 8.66408 9.54123C8.53143 9.47513 8.10384 9.33585 7.59682 8.88632C7.20236 8.53632 6.93596 8.10429 6.85857 7.97208C6.78115 7.83989 6.85042 7.76847 6.91661 7.70288C6.9762 7.64362 7.04929 7.54865 7.11575 7.47166C7.18224 7.39466 7.20414 7.33947 7.24843 7.25158C7.29276 7.16344 7.2706 7.08648 7.2375 7.02036C7.20438 6.95427 6.93904 6.30466 6.82826 6.04053C6.72052 5.78323 6.61104 5.81818 6.5298 5.81387C6.45237 5.81007 6.36402 5.80931 6.2754 5.80931C6.18677 5.80931 6.04313 5.84224 5.92141 5.97443C5.79969 6.10662 5.45691 6.42597 5.45691 7.07531C5.45691 7.72465 5.93237 8.35248 5.99883 8.44061C6.06529 8.52875 6.93469 9.86161 8.2658 10.4335C8.58236 10.5694 8.82962 10.6507 9.02239 10.7115C9.34023 10.8121 9.6295 10.7979 9.85818 10.7639C10.1131 10.726 10.6433 10.4446 10.7538 10.1364C10.8643 9.82817 10.8643 9.56377 10.8312 9.50881C10.7982 9.45386 10.7095 9.42068 10.5768 9.35459L10.5771 9.35409Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1262_3720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1262_3720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 10.6667,
    fill: "white",
    transform: "translate(2.80005 2.96655)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWhatsApp);
export default __webpack_public_path__ + "static/media/ic_WhatsApp.a1652c8fceb61411ffe118824b998ed2.svg";
export { ForwardRef as ReactComponent };